// 4단계(기초/정리/적용/확장) × 2상태(부족/강점) × 5문장 코칭 DB

export const stageFeedbackLibrary = {
  basic: {
    // 기초 단계 (자아효능감 + 학습의지) 부족
    weak: [
      '현재 학생은 스스로 할 수 있다는 자신감과 공부를 시작하려는 의지가 다소 낮은 상태입니다.',
      '학습에 대한 효능감과 의지가 충분히 형성되지 않아, 공부를 시작하고 지속하는 데 어려움을 겪고 있습니다.',
      '현재 학습의 기초 동력인 자아효능감과 학습의지가 낮아, 작은 과제도 부담으로 느껴질 수 있는 상태입니다.',
      '공부를 해도 달라질 수 있다는 믿음이 흔들리고 있어, 학습 출발 자체가 어려운 단계입니다.',
      '지금은 학습 의지와 자신감을 다시 세우는 것이 가장 먼저 필요한 상황입니다.',
    ],
    // 기초 단계 강점
    strong: [
      '학생은 스스로 해낼 수 있다는 자신감과 공부를 시작하려는 의지가 안정적으로 형성되어 있습니다.',
      '자아효능감과 학습의지가 높아, 새로운 도전에도 흔들리지 않는 학습 기반을 갖추고 있습니다.',
      '공부에 대한 믿음과 의지가 탄탄하여, 어떤 상황에서도 학습을 시작하고 지속할 수 있는 힘이 있습니다.',
      '학습의 가장 중요한 동력인 효능감과 의지가 잘 갖춰져 있어, 이를 발판으로 더 높이 성장할 수 있습니다.',
      '스스로 해낼 수 있다는 믿음이 강하며, 이것이 학습 전반을 떠받치는 강점이 되고 있습니다.',
    ],
  },

  organize: {
    // 정리 단계 (효율성) 부족
    weak: [
      '학습 내용을 구조화하고 핵심을 정리하는 능력이 부족하여, 공부 시간 대비 효과가 낮게 나타나고 있습니다.',
      '배운 내용을 요약하거나 중요도를 구분하는 습관이 아직 자리 잡지 못해, 학습이 산만해지기 쉬운 상태입니다.',
      '현재 학습 효율성이 낮아, 같은 시간을 투자해도 성과가 잘 드러나지 않는 경향이 있습니다.',
      '정보를 정리하고 체계화하는 역량이 부족하여 시험 전 복습이나 암기에서 어려움을 겪을 수 있습니다.',
      '학습 내용을 구조적으로 정리하는 방법이 아직 익숙하지 않아, 효율적인 공부 방식을 새로 익혀야 할 시점입니다.',
    ],
    // 정리 단계 강점
    strong: [
      '학습 내용을 체계적으로 정리하고 핵심을 구분하는 능력이 뛰어나, 시간 대비 학습 효율이 높습니다.',
      '배운 내용을 구조화하고 요약하는 습관이 잘 형성되어 있어, 기억 유지와 시험 대비에 강점을 보입니다.',
      '학습 효율성이 높아, 짧은 시간에도 핵심을 잘 파악하고 활용할 수 있는 능력을 갖추고 있습니다.',
      '정보를 정리하고 체계화하는 데 익숙하여, 복잡한 내용도 깔끔하게 이해하고 정리해 냅니다.',
      '학습 내용을 구조적으로 다루는 능력이 강점으로, 이를 바탕으로 심화 학습에서도 좋은 성과를 낼 수 있습니다.',
    ],
  },

  apply: {
    // 적용 단계 (성실성) 부족
    weak: [
      '학습 계획을 세워도 꾸준히 실행하는 데 어려움이 있어, 학습의 실질적인 효과가 나타나기 어려운 상태입니다.',
      '매일 반복적으로 공부하는 습관이 아직 충분히 형성되지 않아, 아는 내용을 실제 실력으로 굳히기가 어렵습니다.',
      '성실성이 낮아 계획대로 실천하는 데 자주 어려움을 겪으며, 꾸준함이 가장 필요한 단계입니다.',
      '배운 내용을 반복 적용하고 연습하는 시간이 부족하여, 실력이 안정적으로 쌓이지 않고 있습니다.',
      '지금 가장 필요한 것은 작은 목표라도 매일 꾸준히 실천하는 습관을 만드는 것입니다.',
    ],
    // 적용 단계 강점
    strong: [
      '매일 꾸준히 학습을 실천하는 성실함이 높아, 아는 것을 실력으로 안정적으로 전환하고 있습니다.',
      '계획한 것을 끝까지 실행하는 능력이 뛰어나, 학습 내용이 탄탄하게 축적되는 강점이 있습니다.',
      '성실성이 높아 반복 연습과 꾸준한 실천이 자연스럽게 이루어지며, 실력이 꾸준히 성장하고 있습니다.',
      '학습을 매일 지속하는 습관이 잘 형성되어 있어, 장기적으로 안정된 성과를 기대할 수 있습니다.',
      '꾸준함이라는 강점이 있어, 시간이 지날수록 학습의 복리 효과가 나타나는 패턴을 보이고 있습니다.',
    ],
  },

  expand: {
    // 확장 단계 (비전) 부족
    weak: [
      '공부를 해야 하는 이유나 미래 목표가 아직 뚜렷하지 않아, 학습의 방향감을 잡기 어려운 상태입니다.',
      '비전과 진로 목표가 명확하지 않아, 지금 하는 공부가 왜 필요한지 연결이 잘 되지 않는 상황입니다.',
      '장기적인 목표 의식이 부족하여, 공부의 동기가 외부 자극에 의존하는 경향이 있습니다.',
      '진로나 목표에 대한 구체적인 그림이 아직 없어, 학습의 의미를 깊이 느끼기 어려울 수 있습니다.',
      '지금은 내가 왜 공부하는지, 어디를 향해 가고 있는지를 탐색하고 구체화하는 것이 중요한 시점입니다.',
    ],
    // 확장 단계 강점
    strong: [
      '공부해야 하는 이유와 미래 목표가 명확하여, 학습에 대한 내적 동기가 강하게 작동하고 있습니다.',
      '진로 목표와 비전이 뚜렷하여, 지금의 학습이 미래와 어떻게 연결되는지 스스로 잘 알고 있습니다.',
      '장기적인 목표 의식이 높아, 힘든 상황에서도 스스로 동기를 유지하고 다시 시작할 수 있습니다.',
      '비전이 명확하여 학습의 방향이 흔들리지 않으며, 이것이 다른 모든 학습 영역을 지지하는 힘이 됩니다.',
      '미래에 대한 구체적인 그림이 있어, 공부하는 의미와 가치를 스스로 만들어 나가는 학생입니다.',
    ],
  },
}

// 단계 메타데이터
export const STAGE_META = {
  basic:    { label: '기초',  domains: ['selfEfficacy', 'learningWill'], color: '#6366f1' },
  organize: { label: '정리',  domains: ['efficiency'],                   color: '#8b5cf6' },
  apply:    { label: '적용',  domains: ['diligence'],                    color: '#a855f7' },
  expand:   { label: '확장',  domains: ['vision'],                       color: '#c084fc' },
}

export const STAGE_ORDER = ['basic', 'organize', 'apply', 'expand']

// 단계별 실행 과제
export const STAGE_TASKS = {
  basic:    ['천천히 읽기', '단어 정리', '인강 듣기'],
  organize: ['요점정리', '핵심 개념 암기'],
  apply:    ['문제 풀이', '오답노트', '백지복습'],
  expand:   ['설명하기', '문제 만들기', '탐구'],
}
